// src/main.jsx
import '@/index.css'
import '@/components/PortalLoginGateway.css'

function resolveBootTarget() {
  const forcedHost = import.meta.env.VITE_FORCE_TERMINAL_HOST?.toLowerCase()

  if (forcedHost === 'kds' || forcedHost === 'pos' || forcedHost === 'comps') {
    return 'terminal'
  }
  if (forcedHost === 'checkin') {
    return 'checkin'
  }
  if (forcedHost === 'starter' || forcedHost === 'bagcart') {
    return 'clubOps'
  }

  if (typeof window === 'undefined') {
    return 'portal'
  }

  const hostname = window.location.hostname || ''

  if (hostname.startsWith('kds.') || hostname.startsWith('pos.') || hostname.startsWith('comps.')) {
    return 'terminal'
  }
  if (hostname.startsWith('checkin.')) {
    return 'checkin'
  }
  if (hostname === 'starter.privana.club' || hostname === 'bagcart.privana.club') {
    return 'clubOps'
  }
  if (hostname === 'dininghost.privana.club' || hostname.startsWith('dininghost.')) {
    return 'diningHost'
  }

  return 'portal'
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element missing for app bootstrap')
}

const bootTarget = resolveBootTarget()
const bootPromise =
  bootTarget === 'terminal'
    ? import('./boot/terminalBoot.jsx')
    : bootTarget === 'checkin'
      ? import('./boot/checkinBoot.jsx')
      : bootTarget === 'clubOps'
        ? import('./boot/clubOpsBoot.jsx')
        : bootTarget === 'diningHost'
          ? import('./boot/diningHostBoot.jsx')
    : import('./boot/portalBoot.jsx')

bootPromise.then((module) => {
  module.boot(rootElement)
})
